/**
 * Where the two recorded-visit pushes open, for RootNavigator's warm and cold
 * routing (one parser, so the two blocks can't drift):
 *
 *   appointment_recording  the plan chat, with the consent sheet for the
 *                          appointment. The tap opens a question; nothing
 *                          records until the person taps Start.
 *   visit_summary_ready    the plan chat, with that recording's summary card.
 */
import type { PendingNotificationNav } from '../navigation/pendingNotificationNav';

const EVENT_ID = /^[A-Za-z0-9._~:@-]{1,512}$/;
const RECORDING_ID = /^[A-Za-z0-9-]{8,64}$/;

const text = (value: unknown, max = 120): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed ? trimmed.slice(0, max) : undefined;
};

export function visitRecordingPushNav(category: string | null | undefined, data: Record<string, any> | null | undefined): PendingNotificationNav | null {
  const kind = category || data?.type;
  const projectId = Number(data?.project_id);
  if (!Number.isSafeInteger(projectId) || projectId <= 0) return null;
  if (kind === 'appointment_recording') {
    const eventId = text(data?.event_id, 512);
    if (!eventId || !EVENT_ID.test(eventId)) return null;
    return {
      projectId,
      screen: 'ProjectChat',
      recordEventId: eventId,
      recordLabel: text(data?.doctor_label),
      recordStart: text(data?.start_time, 40),
    };
  }
  if (kind === 'visit_summary_ready') {
    const recordingId = text(data?.recording_id, 64);
    return {
      projectId,
      screen: 'ProjectChat',
      ...(recordingId && RECORDING_ID.test(recordingId) ? { visitRecordingId: recordingId } : {}),
    };
  }
  return null;
}

/** The ProjectChat params for one of those intents. */
export function visitRecordingChatParams(nav: PendingNotificationNav): Record<string, unknown> {
  return {
    projectId: nav.projectId,
    record: nav.recordEventId,
    recordLabel: nav.recordLabel,
    recordStart: nav.recordStart,
    visitRecordingId: nav.visitRecordingId,
  };
}
